import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const benefits = [
  {
    number: "01",
    title: "Live expert instruction",
    desc:
      "Learn directly from experienced professionals working in the industry.",
  },
  {
    number: "02",
    title: "Practical projects",
    desc: "Apply your learning to realistic business and technology problems.",
  },
  {
    number: "03",
    title: "Coaching-led learning",
    desc:
      "Receive guidance, feedback and accountability throughout the program.",
  },
  {
    number: "04",
    title: "Portfolio development",
    desc: "Graduate with work you can present to employers and clients.",
  },
  {
    number: "05",
    title: "Career preparation",
    desc:
      "Build your résumé, LinkedIn profile, interview skills and workplace readiness.",
  },
];

const HomeLearningModelSection = () => {
  return (
    <section className="bg-[#080a58] text-white py-16 md:py-24 px-4">
      <div className="container mx-auto grid home-grid-0713 gap-10 lg:gap-20">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 text-secondary text-sm font-poppins font-extrabold tracking-[0.1em] uppercase mb-5">
              <span className="w-8 h-[3px] bg-secondary inline-block"></span>
              The Utiva learning model
            </p>
            <h2 className="text-white font-semibold font-poppins tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-5xl mb-5">
              Don&apos;t just watch lessons. Build evidence of what you can do.
            </h2>
            <p className="text-[#d5dcff] text-base font-poppins leading-[1.8] mb-6">
              Utiva combines live learning, practical projects, assessments,
              coaching and career preparation to help you build capabilities
              employers can recognise.
            </p>
            <Link
              to="/start"
              className="bg-secondary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:-translate-y-0.5 transition-all"
            >
              Find Your Program{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </Link>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {benefits.map((benefit) => (
              <article
                key={benefit.number}
                className="border bg-[#ffffff0e] border-[#ffffff29] rounded-2xl p-6"
              >
                <div className="flex gap-3">
                  <span className="text-secondary font-poppins text-sm font-extrabold">
                    {benefit.number}
                  </span>
                  <div>
                    <h3 className="text-lg mb-2 font-semibold font-poppins">
                      {benefit.title}
                    </h3>
                    <p className="text-[#d5dcff] font-poppins text-sm leading-[1.7] m-0">
                      {benefit.desc}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeLearningModelSection;
